export default {
  START_WORKING_VISITOR: 'StartWorking_visitorClick',
};
